module.exports = __webpack_public_path__ + "static/img/phillips-billy.1b3c91e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phillips-billy.jpg
// module id = PN7/
// module chunks = 0